import Parse from "parse";
import debug from "src/modules/debug-logger";
import { Server, ProtoBuff } from "../SynchronizableItemsEnum";

export async function getSyncState() {
  const syncState = await Parse.Cloud.run("getSyncState");

  const syncStateProtoBuffValuesAsKeys = Object.keys(syncState).reduce(
    function useProtoBuffValuesAsKeys(withProtoBuffKeys, itemName) {
      if (!Server[itemName]) return withProtoBuffKeys;

      const protoBuffKey = Server[itemName].protoBuffValue;

      withProtoBuffKeys[protoBuffKey] = syncState[itemName];
      return withProtoBuffKeys;
    },
    {}
  );

  debug.synchronizer("parsed syncState", syncStateProtoBuffValuesAsKeys);

  return syncStateProtoBuffValuesAsKeys;
}

export function confirmItemSync(item) {
  debug.synchronizer(`confirmItemSync called with itemName ${item}`);
  const { serverValue } = ProtoBuff[item];
  debug.synchronizer(`resolved itemName to server value ${serverValue}`);
  return Parse.Cloud.run("confirmItemSync", { item: serverValue });
}
